import React, { Component } from 'react';
import Input from '~/components/shared/input_field';
import I18n from '~/utils/translations';

export default class RentChargeInput extends Component {
  render() {
    const { value, onChange, onBlur, errors } = this.props;
    return (
      <div className="rent-charge-input">
        <div className="charge-input-group">
          <p className="charge-label">{I18n.t('pages.agents_form.charges.rent_label')}</p>
          <div className="input-wrapper">
            <Input
              name="price"
              type="text"
              animatedPlaceholder={I18n.t('pages.agents_form.charges.amount_placeholder')}
              prepend={I18n.t('currency.symbol')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              errors={errors}
            />
          </div>
        </div>
      </div>
    );
  }
}
